// Minimal API client for the React app — mirrors the vanilla frontend's api():
// same-origin /api, cookie session (credentials: 'include'), JSON in/out, 401 →
// a global 'auth-required' event so the shell can re-gate.

export const API_BASE = '/api';

// Read-only gate: when the signed-in user's role is read-only (viewer, or agency
// Analyst), block writes client-side with a friendly error before they hit the
// server (the backend enforces the same — this just makes the UX immediate).
// Mirrors the server's allow-list: own security + logout still go through.
let _readOnly = false;
export function setReadOnly(v) { _readOnly = !!v; }
export function isReadOnly() { return _readOnly; }
const _roAllowed = (p) => p === '/auth/logout' || p === '/account/password' || p.startsWith('/account/2fa') || p.startsWith('/account/sessions');

export async function api(path, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  if (_readOnly && method !== 'GET' && method !== 'HEAD' && !_roAllowed(path)) {
    const err = new Error('Your access is read-only.'); err.status = 403; err.code = 'READ_ONLY';
    throw err;
  }
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });

  let data = null;
  try { data = await res.json(); } catch { /* non-JSON / empty */ }

  if (!res.ok) {
    if (res.status === 401) document.dispatchEvent(new CustomEvent('auth-required'));
    const err = new Error((data && data.error) || `Request failed (${res.status})`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

// Auth session probe. Returns { authenticated, auth_required, user?, account?, role?, impersonation? }.
// Never throws — a down/unconfigured backend resolves to a safe "not authenticated, not required".
export async function getMe() {
  try {
    return await api('/auth/me');
  } catch {
    return { authenticated: false, auth_required: false };
  }
}

export const logout   = () => api('/auth/logout', { method: 'POST', body: '{}' });
